import * as React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import { ListItemButton, ListItemIcon } from "@mui/material/";
import Stack from "@mui/material/Stack";
import TaskOutlinedIcon from "@mui/icons-material/TaskOutlined";
import Typography from "@mui/material/Typography";
import { NavLink } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { useLocation } from "react-router-dom";
import ViewTimelineIcon from '@mui/icons-material/ViewTimeline';

export default function MenuContent() {
  const location = useLocation();
  const theme = useTheme();
  const mainListItems = [
    
    { text: "Audit List", icon: <TaskOutlinedIcon />, path: "/audit-list" },
    { text: "Timeline View", icon: <ViewTimelineIcon />, path: "/timeline-view" },
  ];
  return (
    <Stack>
      <List dense>
        {mainListItems.map(({ text, path, icon }, index) => (
          <ListItem
            key={index}
            disablePadding
            sx={{ display: "block", color: "#000", pb: "15px" }}
            component={NavLink}
            to={path}
          >
            <ListItemButton
              sx={{
                alignSelf: "center",
                pb: "0px",
              }}
            >
              <ListItemIcon
                sx={{
                  justifyContent: "center",
                  color: theme.palette.text.primary,
                  ...(location.pathname.includes(path) && {
                    color: "#fff",
                  }),
                }}
              >
                <span
                  style={{
                    ...(location.pathname.includes(path) && {
                      backgroundColor:
                        theme.palette.mode === "dark"
                          ? theme.palette.primary.dark
                          : theme.palette.primary.main,
                      paddingTop: "6px",
                      paddingLeft: "4px",
                      paddingRight: "4px",
                      borderRadius: "5px",
                    }),
                    paddingBottom: "0px",
                  }}
                >
                  {" "}
                  {icon}
                </span>
              </ListItemIcon>
            </ListItemButton>
            <Typography
              sx={{
                alignSelf: "center",
                textAlign: "center",
                pt: 0,
                color: theme.palette.text.primary,
                ...(location.pathname.includes(path) && {
                  color:
                    theme.palette.mode === "dark"
                      ? theme.palette.text.primary
                      : theme.palette.primary.main,
                  fontWeight: "bold",
                }),
              }}
            >
              {text}
            </Typography>
          </ListItem>
        ))}
      </List>
    </Stack>
  );
}
